// extracted by mini-css-extract-plugin
export default {"card_header":"CardHeader_card_header__pu6E1","title":"CardHeader_title__b2dHu"};